import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../views/HomePage.vue";
import ComTest from "../views/temp/ComTest.vue";

// -------------- TEMP PAGES -----------------
import PageA from "../views/temp/PageA.vue";
import PageB from "../views/temp/PageB.vue";
import PageC from "../views/temp/PageC.vue";
import PageD from "../views/temp/PageD.vue";
import PageE from "../views/temp/PageE.vue";
import PageF from "../views/temp/PageF.vue";
import PageG from "../views/temp/PageG.vue";
import PageH from "../views/temp/PageH.vue";

// -------------- Home -----------------

import HomeAbout from "../views/Home/HomeAbout.vue";
import HomeFAQ from "../views/Home/HomeFAQ.vue";
import LandingPage from "@/views/Home/LandingPage.vue";

// -------------- Contractor Mgmt -----------------

import AddPerson from "../views/ContractorMgmt/AddPerson.vue";
import PersonTransfer from "../components/ProcessMasterListViews/PersonTransfer.vue";
import MultiPersonTransfer from "../components/ProcessMasterListViews/MultiPersonTransfer.vue";
import ProcessMasterListA from "../views/ContractorMgmt/ProcessMasterListA.vue";
import RevocationSearch from "../views/ContractorMgmt/RevocationSearch.vue";
import DashBoard from "../views/ContractorMgmt/DashBoard.vue";
import AccountManagement from "../views/ContractorMgmt/AccountManagement.vue";

// -------------- Reports -----------------

import ArmingCompliance from "../views/Reports/ArmingCompliance.vue";
import ArmingRosterExp from "../views/Reports/ArmingRosterExp.vue";
import ArmedByLocation from "../views/Reports/ArmedByLocation.vue";
import ConsusReport from "../views/Reports/ConsusReport.vue";
import DocExpiration from "../views/Reports/DocExpiration.vue";
import ConfirmDate from "../views/Reports/ConfirmDate.vue";
import VendorKcorPoc from "../views/Reports/VendorKcorPoc.vue";
import LookForwardContract from "../views/Reports/LookForwardContract.vue";
import LookForwardTotals from "../views/Reports/LookForwardTotals.vue";
import NonStandardWeaponPerson from "../views/Reports/NonStandardWeaponPerson.vue";
import NonUsStatus from "../views/Reports/NonUsStatus.vue";
import RevocationWatchList from "../views/Reports/RevocationWatchList.vue";
import StatusRenewal from "../views/Reports/StatusRenewal.vue";
import TotalsBySecurityType from "../views/Reports/TotalsBySecurityType.vue";

// -------------- Processing -----------------

import AalLetterGeneration from "../views/Processing/AalLetterGeneration.vue";
import AcodQualityControl from "../views/Processing/AcodQualityControl.vue";
import ContractDashboard from "../views/Processing/ContractDashboard.vue";
import LegalReview from "../views/Processing/LegalReview.vue";
import LegalReviewComplete from "../views/Processing/LegalReviewComplete.vue";
import ProcessMasterList from "../views/Processing/ProcessMasterList.vue";
import ProcessMasterListB from "../views/Processing/ProcessMasterListB.vue";

// -------------- Administration -----------------

// ++++++ Engineering

import AppColors from "../views/Administration/Engineering/AppColors.vue";
import HostCmpGrid from "../views/Administration/Engineering/HostCmpGrid.vue";
import HostCmpGridComplete from "../views/Administration/Engineering/HostCmpGridComplete.vue";
import HostCmpGridActions from "../views/Administration/Engineering/HostCmpGridActions.vue";
import DocCompHosting from "../views/Administration/Engineering/DocCompHosting.vue";
import DocCompDocUpdload from "../views/Administration/Engineering/DocCompDocUpload.vue";
import HostFileDownloadTesting from "../views/Administration/Engineering/HostFileDownloadTesting.vue";
import PageTemplate from "../views/Administration/Engineering/PageTemplate.vue";
import HostUploadAgent from "../views/Administration/Engineering/HostUploadAgent.vue";
import DocumentDownload from "../views/Administration/Engineering/DocumentDownload.vue";

// ++++++ Main

import AgencyRecords from "../views/Administration/Main/AgencyRecords.vue";
import CompanyRecords from "../views/Administration/Main/CompanyRecords.vue";
import ContractRecords from "../views/Administration/Main/ContractRecords.vue";
import ArmingAuthorityRecords from "../views/Administration/Main/ArmingAuthorityRecords.vue";
import SearchAdmin from "../views/Administration/Main/SearchAdmin.vue";

import UserRecords from "../views/Administration/Main/Users/UserRecords.vue";
import EditUser from "../views/Administration/Main/Users/EditUser.vue";

import StatusTracker from "../views/Administration/Main/StatusTracker.vue";
import AddPersonAdmin from "../views/Administration/Main/AddPersonAdmin.vue";
import DuplicateRecordMgmt from "../views/Administration/Main/DuplicateRecordReport.vue";
import CampLocationMgmt from "../views/Administration/Main/CampLocationMgmt/CampLocationMgmt.vue";
import ContractUserMgmt from "../views/Administration/Main/ContractUserMgmt/ContractUserMgmt.vue";

//REGISTRATION LANDING PAGE
import RegistrationLandingPage from "../components/Login/RegistrationLandingPage.vue";

//contract persons
import PersonsByContractMaster from "@/components/ProcessMasterListViews/PersonsByContractMasterPage.vue";
import PersonsByContractHold from "@/components/ProcessMasterListViews/PersonsByContractHoldPage.vue";
import PersonEditPage from "@/components/ProcessMasterListViews/EditPersonPage.vue";
import AdminPersonEditPage from "@/components/ProcessMasterListViews/AdminEditPersonPage.vue";
import PersonsByContractNew from "@/components/ProcessMasterListViews/PersonsByContractNewPage.vue";
import PersonsByContractQC from "@/components/ProcessMasterListViews/PersonsByContractQCPage.vue";
import PersonsByContractComplete from "@/components/ProcessMasterListViews/PersonsByContractCompletePage.vue";
//contract person by expiration
import PersonsByQualExpiration from "@/components/RequiringActionTable/PersonListByQualExpiration.vue";

const routes = [

  // ++++++++++++ Home

  {
    path: "/",
    name: "home",
    component: HomePage,
  },
  {
    path:"/:pathMatch(.*)*", 
    name: "not-found", 
    component:HomePage
  },

  {

    path: "/landing",
    name: "landing",
    component: LandingPage,
  },

  {

    path: "/homeAbout",
    name: "homeAbout",
    component: HomeAbout,
  },

  {
    path: "/homeFAQ",
    name: "homeFAQ",
    component: HomeFAQ,
  },

  // ++++++++++++ Contractor Mgmt

  {
    path: "/addPerson/:contractId/:contractNumber",
    name: "addPerson",
    component: AddPerson,
  },

  {
    path: "/personTransfer/:personID/:firstName/:lastName/:contractId/:contractNumber",
    name: "personTransfer",
    component: PersonTransfer,
  },

  {
    path: "/multiPersonTransfer/:contractId/:contractNumber",
    name: "multiPersonTransfer",
    component: MultiPersonTransfer,
  },

  // {
  //   path: "/personTransfer/:userData",
  //   name: "personTransfer",
  //   component: PersonTransfer,
  // },

  {
    path: "/processMasterListA",
    name: "processMasterListA",
    component: ProcessMasterListA,
  },

  {
    path: "/revocationSearch",
    name: "revocationSearch",
    component: RevocationSearch,
  },

  {
    path: "/dashBoard",
    name: "deashBoard",
    component: DashBoard,
  },

  {
    path: "/accountManagement",
    name: "accountManagement",
    component: AccountManagement,
  },

  {
    path: "/armingRosterExp",
    name: "armingRosterExp",
    component: ArmingRosterExp,
  },// ++++++++++++ Reports

  {
    path: "/armingCompliance",
    name: "armingCompliance",
    component: ArmingCompliance,
  },

  {
    path: "/armedByLocation",
    name: "armedByLocation",
    component: ArmedByLocation,
  },

  {
    path: "/consusReport",
    name: "consusReport",
    component: ConsusReport,
  },
  {
    path: "/docExpiration",
    name: "docExpiration",
    component: DocExpiration,
  },
  {
    path: "/confirmDate",
    name: "confirmDate",
    component: ConfirmDate,
  },
  {
    path: "/vendorKcorPoc",
    name: "vendorKcorPoc",
    component: VendorKcorPoc,
  },
  {
    path: "/lookForwardContract",
    name: "lookForwardContract",
    component: LookForwardContract,
  },
  {
    path: "/lookForwardTotals",
    name: "lookForwardTotals",
    component: LookForwardTotals,
  },
  {
    path: "/nonStandardWeaponPerson",
    name: "nonStandardWeaponPerson",
    component: NonStandardWeaponPerson,
  },
  {
    path: "/nonUsStatus",
    name: "nonUsStatus",
    component: NonUsStatus,
  },
  {
    path: "/revocationWatchList",
    name: "revocationWatchList",
    component: RevocationWatchList,
  },
  {
    path: "/statusRenewal",
    name: "statusRenewal",
    component: StatusRenewal,
  },
  {
    path: "/totalsBySecurityType",
    name: "totalsBySecurityType",
    component: TotalsBySecurityType,
  },
  // ++++++++++++ Processing

  {
    path: "/contractDashboard",
    name: "contractDashboard",
    component: ContractDashboard,
  },

  {
    path: "/processMasterListB",
    name: "processMasterListB",
    component: ProcessMasterListB,
  },

  {
    path: "/processMasterList",
    name: "processMasterList",
    component: ProcessMasterList,
  },

  {
    path: "/acodQualityControl",
    name: "acodQualityControl",
    component: AcodQualityControl,
  },

  {
    path: "/legalReview",
    name: "legalReview",
    component: LegalReview,
  },

  {
    path: "/legalReviewComplete",
    name: "legalReviewComplete",
    component: LegalReviewComplete,
  },

  {
    path: "/aalLetterGeneration",
    name: "aalLetterGeneration",
    component: AalLetterGeneration,
  },

  // ++++++++++++ Administration - Main
  {
    path: "/agencyRecords",
    name: "agencyRecords",
    component: AgencyRecords,
  },

  {
    path: "/companyRecords",
    name: "companyRecords",
    component: CompanyRecords,
  },

  {
    path: "/contractRecords",
    name: "contractRecords",
    component: ContractRecords,
  },

  {
    path: "/armingAuthorityRecords",
    name: "armingAuthorityRecords",
    component: ArmingAuthorityRecords,
  },

  {
    path: "/searchAdmin",
    name: "searchAdmin",
    component: SearchAdmin,
  },

  {
    path: "/userRecords",
    name: "userRecords",
    component: UserRecords,
  },

  {
    path: "/editUser/:userProfileIdParam/:userGUIDParam/:lastNameParam/:actionIsEdit/:actionIsCreate/:actionIsNonAdminEdit",
    name: "editUser",
    component: EditUser,
  },

  {
    path: "/statusTracker",
    name: "statusTracker",
    component: StatusTracker,
  },

  {
    path: "/addPersonAdmin",
    name: "addPersonAdmin",
    component: AddPersonAdmin,
  },

  {
    path: "/duplicateRecordMgmt",
    name: "duplicateRecordMgmt",
    component: DuplicateRecordMgmt,
  },

  {
    path: "/campLocationMgmt",
    name: "campLocationMgmt",
    component: CampLocationMgmt,
  },

  {
    path: "/contractUserMgmt",
    name: "contractUserMgmt",
    component: ContractUserMgmt,
  },


  // ++++++++++++ Administration - Engineering
  {
    path: "/appColors",
    name: "appColors",
    component: AppColors,
  },
  {
    path: "/hostCmpGrid",
    name: "hostCmpGrid",
    component: HostCmpGrid,
  },

  {
    path: "/HostCmpGridComplete",
    name: "hostCmpGridComplete",
    component: HostCmpGridComplete,
  },

  {
    path: "/hostCmpGridActions",
    name: "hostCmpGridActions",
    component: HostCmpGridActions,
  },

  {
    path: "/docCompHosting",
    name: "docCompHosting",
    component: DocCompHosting,
  },

  {
    path: "/docCompDocUpdload",
    name: "docCompDocUpdload",
    component: DocCompDocUpdload,
  },

  {
    path: "/hostFileDownloadTesting",
    name: "hostFileDownloadTesting",
    component: HostFileDownloadTesting,
  },

  {
    path: "/pageTemplate",
    name: "pageTemplate",
    component: PageTemplate,
  },

  {
    path: "/hostUploadAgent",
    name: "hostUploadAgent",
    component: HostUploadAgent,
  },
  
  {
    path: "/documentDownload",
    name: "documentDownload",
    component: DocumentDownload,
  },

  // ++++++++++++ Temp

  {
    path: "/comTest",
    name: "comTest",
    component: ComTest,
  },
  {
    path: "/pagea",
    name: "pagea",
    component: PageA,
  },
  {
    path: "/pageb",
    name: "pageb",
    component: PageB,
  },
  {
    path: "/pagec",
    name: "pagec",
    component: PageC,
  },
  {
    path: "/paged",
    name: "paged",
    component: PageD,
  },
  {
    path: "/pagee",
    name: "pagee",
    component: PageE,
  },
  {
    path: "/pagef",
    name: "pagef",
    component: PageF,
  },
  {
    path: "/pageg",
    name: "pageg",
    component: PageG,
  },
  {
    path: "/pageh",
    name: "pageh",
    component: PageH,
  },
  {
    path: "/registrationSuccess",
    name: "RegistrationLanding",
    component: RegistrationLandingPage,
  },
  {
    path: "/PersonsByContract/:contractId",
    name: "PersonsByContractMaster",
    component: PersonsByContractMaster
  },
  {
    path: "/PersonsByContract/holds/:contractId",
    name: "PersonsByContractHold",
    component: PersonsByContractHold
  },
  {
    path: "/PersonsByContract/new/:contractId",
    name: "PersonsByContractNew",
    component: PersonsByContractNew
  },
  {
    path: "/PersonsByContract/qc/:contractId",
    name: "PersonsByContractQC",
    component: PersonsByContractQC
  },
  {
    path: "/PersonsByContract/complete/:contractId",
    name: "PersonsByContractComplete",
    component: PersonsByContractComplete
  },
  {
    path: "/PersonsByContract/expiration/:contractId",
    name: "PersonsByQualExpiration",
    component: PersonsByQualExpiration
  },
  //PersonsByQualExpiration
  {
    path: "/PersonContract/Edit/:personId",
    name: "PersonEditPage",
    component: PersonEditPage
  },
  {
    path: "/PersonContract/AdminEdit/:personId",
    name: "AdminPersonEditPage",
    component: AdminPersonEditPage
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.resolve({
  name: 'not-found', 
  params: { pathmatch: [ 'not', 'found']},

}).href

export default router;
